











































import Vue from "vue";

export default Vue.extend({
  name: "FilterContainer",
  props: {
    translations: {
      type: Object,
      required: true,
    },
    clickFunction: {
      type: Function,
      required: false,
    },
  },
});
